import CourseNote from './CourseNote';

export default CourseNote;
